import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deliverShipment } from "../../../services/supplierOrderService";
import { shipmentKeys } from "../queryKeys";

export const useDeliverShipment = () => {

  const queryClient = useQueryClient();

  return useMutation({

    mutationFn: ({ shipmentCode, data }) =>
      deliverShipment(shipmentCode, data),

    onSuccess: (_, variables) => {

      queryClient.invalidateQueries(shipmentKeys.all);

      queryClient.invalidateQueries(
        shipmentKeys.detail(variables.shipmentCode)
      );

    },

  });

};
